import httpClient from '@/httpClient/httpClient';
import { ResponseDataProviderValue } from '@/utils/ResponseDataValue';
import { ActionTree, GetterTree, MutationTree } from 'vuex';
import i18n from '@/i18n';
import { Notification } from 'uiv';
import { ResponseBody, ResponseDataProvider, RootState } from '@/types';
import { IDictionaryState } from '@/types/dictionary';

const REQUEST_ERROR = i18n.t('notifications.errorRequest');

const state: IDictionaryState = {
  geoTargets: [],
  trafficTypes: [
    {
      label: i18n.t('body.table.body.trafficType.native') as string,
      value: 'native',
    },
    {
      label: i18n.t('body.table.body.trafficType.banner') as string,
      value: 'banner',
    },
    {
      label: i18n.t('body.table.body.trafficType.push') as string,
      value: 'push',
    },
  ],
};

const mutations: MutationTree<IDictionaryState> = {
  setGeoTargets(state, payload) {
    state.geoTargets = payload.data.map((geo) => geo);
  },
};

const getters: GetterTree<IDictionaryState, RootState> = {
  getGeoTargets(state) {
    return state.geoTargets.map((geo) => ({
      label: geo.name,
      value: geo.code,
      type: geo.type,
    }));
  },
  getTrafficTypes(state) {
    return state.trafficTypes.map(trafficType => trafficType);
  }
};

const actions: ActionTree<IDictionaryState, RootState> = {
  async loadGeoTargets({ commit }, search) {
    try {
      const response: ResponseBody = await httpClient().get(
        '/dictionary/geo-target',
        {
          params: {
            name: search,
          },
        }
      );
      const responseDataProvider: ResponseDataProvider =
        ResponseDataProviderValue(response, true);

      commit('setGeoTargets', responseDataProvider.data);
    } catch (err) {
      Notification.notify.error({
        title: REQUEST_ERROR,
      });
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
